/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.SalesWindow = function( mode, salesObj) {
    var CompanyList = expocadfx.CompanyList;
    var DeletedBoothList = expocadfx.DeletedBoothList;
    var fxStyle = expocadfx.styles;
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var DivideTool = expocadfx.DivideTool;
	var elem = expocadfx.element;
    var elemById = elem.elementById;
    var FxEvent = expocadfx.fxevent;
    var txt = expocadfx.txt;
	var StatsList = expocadfx.StatsList;		// eventstats.js
    var util = expocadfx.util;
    var Dialog = expocadfx.Dialog;
    var body = document.getElementsByTagName( "body")[0];
    var dialogWidth = "400";
    var closeBut;
    var tooltipObj;
    
    var doc = document;
    var salesMode = mode;
    var boothObj = null;
    var hatchObj = null;
    var winSales = elemById( "salesWindow");
    var btnOps = elemById( "sOp");
    var inputBthNum = elemById( "inBthNum");
    var inputName = elemById( "inCompanyName");
    var inputId = elemById( "inCompanyId");
    var inputRate = elemById( "inRate");
    var inputComment = elemById( "inComment");
    var inputAddrOne = elemById('inAddressOne');
    var inputAddrTwo = elemById('inAddressTwo');
    var inputCity = elemById('inCity');
    var inputCountry = elemById('inCountry');
    var inputState = elemById('inState');
    var inputPostalCode = elemById('inPostalCode');
    var inputContact = elemById('inContact');
    var inputPhone = elemById('inPhone');
    var inputFax = elemById('inFax');
    var inputEmail = elemById('inEmail');
    var extraInfo = elemById('sInfo');
    var minExtraInfo = elemById('sInfoMin')
    var inputWebSite = elemById('inWebSite');
    var inputCompanyProfile = elemById('inCompanyProfile');
    var salesPrompt = elemById( "sPrompt");
    var salesAction = elemById( "sControl");
    var divide = null;
	var stats = null;
    var statsHeader = null;
    var tooltipNode;
    
    var sales = salesObj;
    var commandNumber = 0;
    inputBthNum.setAttribute( "readonly", true);
    inputName.setAttribute( "readonly", true);
    inputId.setAttribute( "readonly", true);
    
    var listCompanies = null;
    var listDeletedBoohts = null;
    
    var divCompanies = elemById("divCompanies");
    var divCompanyGrid = null;
    
    var characterLimit = txt.CHARACTER_LIMIT;
    elemById( "sLblBthNum").textContent = txt.BOOTH_NUMBER;
    elemById( "sLblCompanyName").textContent = txt.COMPANY_NAME;
    elemById( "sLblCompanyId").textContent = txt.COMPANY_ID;
    elemById( "sLblRate").textContent = txt.RATE_PLAN;
    elemById( "sLblComment").textContent = txt.COMMENT;
    elemById( "sCancel").textContent = txt.CANCEL;
    elemById( "sNewComp").textContent = txt.NEW_COMPANY;

    elemById("sLblAddressOne").textContent = txt.COMPANY_ADDRESS_ONE;
    elemById("sLblAddressTwo").textContent = txt.COMPANY_ADDRESS_TWO;
    elemById("sLblCity").textContent = txt.COMPANY_CITY;
    elemById("sLblCountry").textContent = txt.COMPANY_COUNTRY;
    elemById("sLblState").textContent = txt.COMPANY_STATE;
    elemById("sLblPostalCode").textContent = txt.COMPANY_POSTAL_CODE;
    elemById("sLblContact").textContent = txt.COMPANY_CONTACT_NAME;
    elemById("sLblPhone").textContent = txt.COMPANY_PHONE_NUMBER;
    elemById("sLblFax").textContent = txt.COMPANY_FAX;
    elemById("sLblEmail").textContent = txt.COMPANY_EMAIL;
    elemById("sLblWebSite").textContent = txt.COMPANY_WEB_SITE;
    elemById("sLblCompanyProfile").textContent = txt.COMPANY_PROFILE;

    btnOps.disabled = true;
    btnOps.textContent = "";
    btnOps.addEventListener( "click", sendCommand);
    elemById( "sCancel").addEventListener( "click", closeWindow);
    elemById( "sNewComp").style.display = "none";

    function returnSalesWindow(){
        data.salesWindow.window.style.display = "block";
        elemById('control1').style.display = "block";
        elemById('btnMenu').style.display = "block";
        elemById('sPrompt2Flag').style.display = "none";  
    }

    function checkComplete() {
        if( commandNumber === sales.CMD_RENT) {
            mobileAddBooth()
            btnOps.disabled = ( inputBthNum.value === "" || 
                               inputId.value === "" ||
                               inputRate.value === txt.SELECT_RATE);
            if(inputBthNum.value !== ""){
                divCompanies.style.display = "block";
                doc.getElementById('sTable').style.display = "none";
                returnSalesWindow();
            }                   
            if(inputId.value !== ""){
                divCompanies.style.display = "none";
                doc.getElementById('sTable').style.display = "block";
            }                   
        }
        else if( commandNumber === sales.CMD_HOLD) {
            mobileAddBooth();
            btnOps.disabled = ( inputBthNum.value === "" || inputName.value === "");
            if(inputBthNum.value !== "" && inputId.parentNode.style.display === 'block'){
                divCompanies.style.display = "block";
                doc.getElementById('sTable').style.display = "none";
            } 
            if(inputBthNum.value !== ""){
                returnSalesWindow()
            }
            if(inputId.value !== ""){
                divCompanies.style.display = "none";
                doc.getElementById('sTable').style.display = "block";
            }    
        }
        else if( commandNumber === sales.CMD_UNHOLD) {
            mobileAddBooth();
            if(inputBthNum.value !== ""){
                returnSalesWindow()
            }
            btnOps.disabled = ( inputBthNum.value === "");
        }
        else if( commandNumber === sales.CMD_COMBINE) {
            mobileAddBooth();
            btnOps.disabled = ( inputBthNum.value.indexOf( ",") === -1);  
            if(inputBthNum.value !== ""){
                returnSalesWindow()
            }
        }
        else if( commandNumber === sales.CMD_NEW_EXHIBITOR) {
            btnOps.disabled = ( inputName.value === "" || inputId.value === "");
            if(window.innerHeight < 601){
                document.querySelectorAll('.dialog__content')[1].style.overflow = 'auto';
            }
           // elemById('addBoothBtn').style.display = "none !important";
            if(inputName.value !== ""){
                elemById('sLblCompanyName').classList.add('salesComplete');

            } else{
                elemById('sLblCompanyName').classList.remove('salesComplete');
            }
            if(inputId.value !== ""){
                elemById('sLblCompanyId').classList.add('salesComplete');
            } else {
                elemById('sLblCompanyId').classList.remove('salesComplete');  
            }
        }
        else if( commandNumber === sales.CMD_DIVIDE) {
            mobileAddBooth();
            if(window.innerHeight < 601){
                elemById('divideContainer').style.margin = "-30px 10% -160px"
            }
            if(inputBthNum.value !== ""){
                returnSalesWindow()
            }
            var btnOpsListen = function(event){
                if(typeof(elemById('aIn')) != 'undefined' && elemById('aIn') != null){
                    btnOps.disabled = ( inputBthNum.value === "" ||
                    elemById( "bNumber").value === "" || 
                    elemById( "aNumber").value === "") || (
                    elemById('aFt').value === "0" && elemById('aIn').value === "0" || elemById('bFt').value === "0" && elemById('bIn').value === "0" ) || (
                    elemById('aFt').value === "" && elemById('aIn').value === "" || elemById('bFt').value === "" && elemById('bIn').value === "" );
                } else {
                    btnOps.disabled = ( inputBthNum.value === "" ||
                               elemById( "bNumber").value === "" || 
                               elemById( "aNumber").value === "") || (
                               elemById('aFt').value === "0" || elemById('bFt').value === "0" ) || (
                               elemById('aFt').value === "" || elemById('bFt').value === "" );
                }
           //  btnOps.disabled = ( inputBthNum.value === "" ||
            //                   elemById( "bNumber").value === "" || 
             //                  elemById( "aNumber").value === "") || (
              //                 elemById('aFt').value === "0" && elemById('aIn').value === "0" || elemById('bFt').value === "0" && elemById('bIn').value === "0" ); 
            };
            document.addEventListener('mousemove', btnOpsListen, false);
            document.addEventListener('keyup', btnOpsListen, false)
            window.setTimeout(function(){
                doc.getElementById('Xtop2').addEventListener('click', function(){
                    document.removeEventListener('mousemove', btnOpsListen, false);
                    document.removeEventListener('keyup', btnOpsListen, false)
                })
                doc.getElementById('sCancel').addEventListener('click', function(){
                    document.removeEventListener('mousemove', btnOpsListen, false);
                    document.removeEventListener('keyup', btnOpsListen, false)
                })
                doc.getElementById('sOp').addEventListener('click', function(){
                    document.removeEventListener('mousemove', btnOpsListen, false);
                    document.removeEventListener('keyup', btnOpsListen, false)
                })
            }, 200)
        }
        else if( commandNumber === sales.CMD_CHANGE_NUMBER) {
            mobileAddBooth();
            btnOps.disabled = ( inputBthNum.value === "" || inputId.value === "");     
            if(inputBthNum.value !== ""){
                elemById('sLblBthNum').classList.add('salesComplete');
                   returnSalesWindow()
            } else {
                elemById('sLblBthNum').classList.remove('salesComplete');
            }
            if(inputId.value !== ""){
                elemById('sLblCompanyId').classList.add('salesComplete');
            } else {
                elemById('sLblCompanyId').classList.remove('salesComplete');
            }
        } 
        else if( commandNumber === sales.CMD_HATCH_BOOTHS) {
            btnOps.disabled = false;
            
        }   
        else {
            btnOps.disabled = ( inputBthNum.value === "");
        }
		
            // Update prompt
        if( commandNumber === sales.CMD_NEW_EXHIBITOR) {
            salesPrompt.textContent = txt.ENTER_NEW_COMPANY;
            if(document.querySelector('.wrongLoginTwo') !== null){
                salesPrompt.classList.remove('wrongLoginTwo');
            }
            extraInfo.style.display = "block";
            minExtraInfo.style.display = "none";
            elemById('addBoothBtnA').style.display = "none";
           // salesHeader.textContent = CMD_NEW_EXHIBITOR;
        }
       
        else if( commandNumber === sales.CMD_UNDELETE) {
                salesPrompt.textContent = txt.SELECT_DELETED_BOOTH;
                elemById('addBoothBtnA').style.display = "none";
                if( /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
                    divCompanies.style.margin = "-65px 24px 25px 20px";
                }
                if(inputBthNum.value !== ""){
                    elemById('sLblBthNum').classList.add('salesComplete');
                } else {
                    elemById('sLblBthNum').classList.remove('salesComplete');
                }
        }
        else if( commandNumber === sales.CMD_EVENT_STATISTICS) {
                salesPrompt.style.display = "none";
                elemById('addBoothBtnA').style.display = "none";
        }
        else if( commandNumber === sales.CMD_HATCH_BOOTHS) {
                salesPrompt.textContent = txt.SELECT_CRITERIA;


        }
        else if( commandNumber === sales.CMD_CHANGE_NUMBER && inputBthNum.value !== "") {
				if( inputId.value === "") {
					salesPrompt.textContent = txt.ENTER_NEW_NUMBER;
				}
				else {
                    salesPrompt.innerHTML = "<i class='fas fa-check'></i>";
				}
        }
        else if( inputBthNum.value === "") {
            salesPrompt.textContent = txt.SELECT_BOOTH;
            elemById('sLblBthNum').classList.remove('salesComplete');
        }
        else {
            if( commandNumber === sales.CMD_UNDELETE && inputBthNum.value === "") {
                salesPrompt.textContent = txt.SELECT_DELETED_BOOTH;
            }
            else if( commandNumber === sales.CMD_NEW_EXHIBITOR) {
                salesPrompt.textContent = txt.ENTER_NEW_COMPANY;

            }
            else if( (commandNumber === 0 || commandNumber === 2) && inputName.value === "") {
                salesPrompt.textContent = txt.SELECT_COMPANY;

                elemById('sLblBthNum').classList.add('salesComplete');
                if( commandNumber === 2) {
                    elemById('sLblCompanyName').classList.remove('salesComplete');
                    salesPrompt.textContent += txt.SELECT_NEW_COMPANY;
                }
            }
            else if( commandNumber === sales.CMD_RENT && inputRate.value === txt.SELECT_RATE) {
                elemById('sLblCompanyId').classList.add('salesComplete');
                elemById('sLblCompanyName').classList.add('salesComplete');
                elemById('sLblRate').classList.remove('salesComplete');
                salesPrompt.textContent = txt.SELECT_RATE;
            }
            else if( commandNumber === sales.CMD_DIVIDE) {
                if( boothObj && boothObj.dimF === "") {
                    salesPrompt.classList.add('wrongLoginTwo');
                    salesPrompt.textContent = txt.NON_RECTANGLE;
                }

                else if( inputBthNum.value === "") {
                    salesPrompt.textContent = txt.SELECT_BOOTH;
                }

                else if(elemById( "bNumber").textContent === "" || elemById( "aNumber").textContent === "") {
                    salesPrompt.textContent = txt.ENTER_BOOTH_NUMBERS;
                    if(document.querySelector('.wrongLoginTwo') !== null){
                        salesPrompt.classList.remove('wrongLoginTwo');
                    }
                    elemById('sLblBthNum').classList.add('salesComplete');
                }
            }
            else {
                elemById('sLblCompanyId').classList.add('salesComplete');
                elemById('sLblCompanyName').classList.add('salesComplete');
                if(commandNumber !== sales.CMD_COMBINE){
                    elemById('sLblBthNum').classList.add('salesComplete');
                    salesPrompt.innerHTML = "<i class='fas fa-check'></i>";
                }
                if(commandNumber === sales.CMD_COMBINE){
                    salesPrompt.textContent = "Select Two or more Booths"
                }
                if(document.querySelector('.wrongLoginTwo') !== null){
                    salesPrompt.classList.remove('wrongLoginTwo');
                }
                elemById('sLblRate').classList.add('salesComplete');
            }
        }
    }

    /////////////DIALOG INIT//////////////
    if(data.headerHeight <= 1){
        var obj = {
            posX: data.viewportWidth - dialogWidth - 8,
            posY:  window.innerHeight / 8,
            draggable: true
        };
    } else {
        var obj = {
            posX: data.viewportWidth - dialogWidth - 8,
            posY:  window.innerHeight / 13,
            draggable: true
        };
    }
    function mobileAddBooth(){
        if(window.innerWidth < 500){
            data.salesWindow.window.style.display = "none";
            elemById('control1').style.display = "none";
            elemById('btnMenu').style.display = "none";
            elemById('sPrompt2Flag').style.display = "block";
            if(salesPrompt.textContent === ""){
                elemById('sPrompt2').innerHTML = txt.SELECT_BOOTH;  
            } else {
                elemById('sPrompt2').innerHTML = salesPrompt.innerHTML;  
            }
        }
    }
    
    data.salesWindow = new Dialog( obj, elemById("appContent"), elemById("mask"));
    var parent = elemById( "salesWindow");
    data.salesWindow.content.appendChild( parent);
    data.salesWindow.window.setAttribute('id', 'salesDialog')
    data.salesWindow.header.setAttribute( "id", "salesHeader");
    elemById('salesHeader').style.backgroundColor = fxStyle.windowHeader.clrBg !== "" ? 
    fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg;
    closeBut = doc.createElement( "button");
    closeBut.textContent = "X";
    closeBut.setAttribute('id', 'Xtop2');
    salesAction.appendChild(closeBut);
    elemById( "Xtop2").addEventListener( "click", closeWindow);
    if(window.innerWidth < 500){
        elemById('addBoothBtn').addEventListener('click', function(e){
            e.preventDefault();
            mobileAddBooth();
        });
        elemById('Xtop3').addEventListener('click', function(){
            data.salesWindow.window.style.display = "block";
            elemById('control1').style.display = "block";
            elemById('btnMenu').style.display = "block";
            elemById('sPrompt2Flag').style.display = "none";  
            closeWindow();
        });
    }

    data.salesWindow.window.addEventListener( "Dialog_Moved", mapMovedHandler);	

    function mapMovedHandler() {
		data.salesWindow.window.removeEventListener( "Dialog_Moved", mapMovedHandler);
		data.userMovedMapSales = true;
    }
    function removeHatchBoothsHandler(e){
        // I like this, but might be overkill since it's so easy to re-hatch
        /*         e.preventDefault();
        swal({
            title: "Remove Hatch Booths",
            text: "Are you sure you wish to remove current hatch booths?",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    sales.clearHatchedBooths()
                }
            })  */    
            sales.clearHatchedBooths();
            closeWindow();

    }
    function mapHatchObj(){
        var hatchSize = document.getElementById("sizeHatch").value;
        var hatchColor = document.getElementById("colorHatch").value
        var hatchRadio = document.querySelectorAll('input[name=hatchRadio]:checked')[0].value
        var hatchGrey = document.getElementById('greyHatch').checked;

        hatchObj = {
            "radio": hatchRadio,
            "size": hatchSize,
            "color": hatchColor,
            "grey": hatchGrey
        }
        //console.log(hatchObj)
    }
    function hatchBoothDisplay(){
        if(elemById("hatchRadioDiv") === null){
            var hatchRadio = document.createElement('div');
            var hatchSize = document.createElement('div');
            var hatchColor = document.createElement('div');
            var hatchGrey = document.createElement('div');
            var table = document.getElementById("sTable");

            hatchRadio.innerHTML = `<input id="availHatch" value="0" name="hatchRadio" type="radio" checked/><label>Available</label>
            <input id="notAvailHatch" value="2" name="hatchRadio" type="radio"/><label>Rented/OnHold</label>
            <input id="allHatch" value="3" name="hatchRadio" type="radio"/><label>All</label>`;
            hatchGrey.innerHTML = `<input id="greyHatch" type="checkbox" checked/><label>Gray Out Other Booths</label>`;
            hatchSize.innerHTML = `<label>Size</label><select class="fx-form-control" id="sizeHatch">
            <option value="" selected></option>
            </select>`;
            hatchColor.innerHTML = `<label>Color</label><input id="colorHatch" value=${config.clrSelected} type="color"/>`;

            var arAreaF = [];
            var arAreaM = [];
            var arDimF = [];
            var arDimM = [];

            for(i = 0; i < data.booths.length; i++) {
                if(config.units === "F"){
                    var area = data.booths[i].areaF.replace(/[^0-9.]/g, '');
                    if(!arAreaF.includes(area) && area != ""){
                        arAreaF.push(area);
                    }
                    if(!arDimF.includes(data.booths[i].dimF)){
                        arDimF.push(data.booths[i].dimF);
                    }
                }
                else if(config.units === "M"){
                    var area = data.booths[i].areaM.replace(/[^0-9.]/g, '');
                    if(!arAreaM.includes(area) && area != ""){
                        arAreaM.push(area);
                    }
                    if(!arDimM.includes(data.booths[i].dimM)){
                        arDimM.push(data.booths[i].dimM);
                    }
                }
            }


            hatchRadio.setAttribute("id", "hatchRadioDiv");
            hatchSize.setAttribute("id", "sizeHatchDiv");
            hatchColor.setAttribute("id", "colorHatchDiv");
            hatchGrey.setAttribute("id", "hatchGreyDiv");

            table.appendChild(hatchRadio);       
            table.appendChild(hatchSize);
            table.appendChild(hatchColor);
            table.appendChild(hatchGrey);

            if (config.units === "F") {

                // Add Radio for Dimension or Area
                var isDim = false;
                var isArea = true;

                if(isArea) {
                    arAreaF.sort(function(a, b){return a-b});

                    for(i = 0; i < arAreaF.length; i++) {
                        var option = document.createElement('option');
                        option.setAttribute("value", arAreaF[i] + " SqFt");
                        option.textContent = arAreaF[i] + " SqFt";
                        elemById("sizeHatch").appendChild(option);
                    }
                }
                else if(isDim) {
                    arDimF.sort();

                    for(i = 0; i < arDimF.length; i++) {
                        var option = document.createElement('option');
                        option.setAttribute("value", arDimF[i]);
                        option.textContent = arDimF[i];
                        elemById("sizeHatch").appendChild(option);
                    }
                }

            }
            else if(config.units === "M") {
                // Add Radio for Dimension or Area
                var isDim = false;
                var isArea = true;

                if(isArea) {
                    arAreaM.sort(function(a, b){return a-b});

                    for(i = 0; i < arAreaM.length; i++) {
                        var option = document.createElement('option');
                        option.setAttribute("value", arAreaM[i] + " m²");
                        option.textContent = arAreaM[i] + " m²";
                        elemById("sizeHatch").appendChild(option);
                    }
                }
                else if(isDim) {
                    arDimM.sort();

                    for(i = 0; i < arDimM.length; i++) {
                        var option = document.createElement('option');
                        option.setAttribute("value", arDimM[i]);
                        option.textContent = arDimM[i];
                        elemById("sizeHatch").appendChild(option);
                    }
                }
            }


            hatchRadio.style.display = "flex";
            hatchSize.style.display = "block";
            hatchColor.style.display = "block";
            hatchGrey.style.display = "flex";
            elemById("greyHatch").style.display = "block";

        } else {
            elemById("hatchRadioDiv").style.display = "flex";
            elemById("sizeHatchDiv").style.display = "block";
            elemById("colorHatchDiv").style.display = "block";
            elemById("hatchGreyDiv").style.display = "flex";
            elemById("greyHatch").style.display = "block";
        }
        if(data.hatchedBooths == true){
            if(elemById("removeHatch") === null){
                var hatchRemove = document.createElement('button');
                hatchRemove.textContent = "Remove"; 
                hatchRemove.setAttribute("id", "removeHatch");
                elemById('sControl').appendChild(hatchRemove);
                elemById('removeHatch').addEventListener('click', removeHatchBoothsHandler);
                elemById("removeHatch").style.display = "block";
            } else {
                elemById("removeHatch").style.display = "block";
            }
        }
    
    }
    /////////////////////////////////////////////

    function openWindow( op) {
        btnOps.disabled = true;
        data.salesWindowOpen = true;       // tell floor plan to send booth clicks here
        commandNumber = txt.arSalesCommands.indexOf( op);

        data.salesWindow.window.style.display = 'block';
        data.salesWindow.action.style.display = 'none';

        winSales.style.backgroundColor = fxStyle.rows.clrEvenBg;
        winSales.style.color = fxStyle.rows.clrEvenText;

        if( commandNumber !== sales.CMD_NEW_EXHIBITOR && commandNumber !== sales.CMD_EVENT_STATISTICS 
            && commandNumber !== sales.CMD_HATCH_BOOTHS) {

            inputBthNum.parentElement.style.display = "block";
        }

        winSales.style.display = "block";
        
        if( commandNumber === sales.CMD_RENT ||
                commandNumber === sales.CMD_HOLD ||
                commandNumber === sales.CMD_UNDELETE ||
				commandNumber === sales.CMD_EVENT_STATISTICS ||
                commandNumber === sales.CMD_DIVIDE) {
            winSales.style.height = "";
            //winSales.style.height = "560px";
        }
        else {
            winSales.style.height = "1";
        }
        
		btnOps.textContent = op;
		if( commandNumber !== sales.CMD_EVENT_STATISTICS) {
			btnOps.style.display = "inline-block";
		}
		else {
			btnOps.style.display = "none";
		}
		
        if( commandNumber === sales.CMD_RENT || commandNumber === sales.CMD_HOLD) {
            if( salesMode === "sales") {
                doc.addEventListener( "Companies_Result", companyListHandler);
                sales.getCompanyList();
            }
            inputName.parentElement.style.display = "block";   

            inputId.parentElement.style.display = "block";
            
            if( commandNumber === sales.CMD_RENT) {
                inputRate.parentElement.style.display = "block";

                // Need to revist this.  Would rather add info to the company list before selection
                /* var infoInterval = setInterval(function(){  
                    if(inputName.value.length !== 0){
                        if(!elemById('info-rent')){
                            tooltipNode = document.createElement('span');
                            inputName.insertAdjacentHTML('afterend', 
                                '<div id="info-rent" class="tooltip"><i class="fas fa-info-circle"></i></div>'
                            );
                            elemById('info-rent').appendChild(tooltipNode)
                            tooltipNode.setAttribute("id", "tooltiptext")
                            tooltipNode.innerHTML = "<p>Contact Details</p>" +
                                                "<small>Contact: " + 
                                                tooltipObj.contact + 
                                                "</small>" +
                                                "<small>Phone: " + 
                                                tooltipObj.phone + 
                                                "</small>" +
                                                "<small>FAX: " + 
                                                tooltipObj.fax + 
                                                "</small>" +
                                                "<small>E-Mail: " + 
                                                tooltipObj.email+ 
                                                "</small>";    
            
                            clearInterval(infoInterval)
                        } else {
                            elemById('tooltiptext').innerHTML = "<p>Contact Details</p>" +
                            "<small>Contact: " + 
                            tooltipObj.contact + 
                            "</small>" +
                            "<small>Phone: " + 
                            tooltipObj.phone + 
                            "</small>" +
                            "<small>FAX: " + 
                            tooltipObj.fax + 
                            "</small>" +
                            "<small>E-Mail: " + 
                            tooltipObj.email+ 
                            "</small>";  

                            elemById('info-rent').style.visibility = "visible";

                            clearInterval(infoInterval)
                        }
                    }
                }, 1000); */
            }
            else {
                inputComment.parentElement.style.display = "block";
                inputComment.removeAttribute( "readonly");
                elemById( "sNewComp").style.display = "inline-block";
                elemById( "sNewComp").addEventListener( "click", newCompanyHandler);
            }
        }
        else if( commandNumber === sales.CMD_UNDELETE) {
            doc.addEventListener( "Result_Deleted_Booths", deletedBoothListHandler);
            sales.getDeletedBoothList();
        }
        else if( commandNumber === sales.CMD_EVENT_STATISTICS) {
            doc.addEventListener( "Result_Event_Statistics", eventStatisticsHandler);
            sales.getEventStatistics();

        }
        else if( commandNumber === sales.CMD_HATCH_BOOTHS) {
            hatchBoothDisplay()            
        }
        else if( commandNumber === sales.CMD_UNRENT || commandNumber === sales.CMD_DELETE || commandNumber === sales.CMD_UNCOMBINE){
            mobileAddBooth();

        }
        else if( commandNumber === sales.CMD_NEW_EXHIBITOR) {
            inputName.parentElement.style.display = "block";
            inputId.parentElement.style.display = "block";

			inputName.removeAttribute( "readonly");
			inputName.value = "";
			inputId.removeAttribute( "readonly");
			inputId.value = "";
			checkComplete();
            function extraExhibFields(){
                inputAddrOne.parentElement.style.display = "block";
                inputAddrTwo.parentElement.style.display = "block";
                inputCity.parentElement.style.display = "block";
                inputCountry.parentElement.style.display = "block";
                inputState.parentElement.style.display = "block";
                inputPostalCode.parentElement.style.display = "block";
                inputContact.parentElement.style.display = "block";
                inputPhone.parentElement.style.display = "block";
                inputFax.parentElement.style.display = "block";
                inputEmail.parentElement.style.display = "block";
                inputWebSite.parentElement.style.display = "block";
                inputCompanyProfile.parentElement.style.display = "block";
                extraInfo.style.display = "none";
                minExtraInfo.style.display = "block";
            }
            function minExtraExhibFields(){
                inputAddrOne.parentElement.style.display = "none";
                inputAddrTwo.parentElement.style.display = "none";
                inputCity.parentElement.style.display = "none";
                inputCountry.parentElement.style.display = "none";
                inputState.parentElement.style.display = "none";
                inputPostalCode.parentElement.style.display = "none";
                inputContact.parentElement.style.display = "none";
                inputPhone.parentElement.style.display = "none";
                inputFax.parentElement.style.display = "none";
                inputEmail.parentElement.style.display = "none";
                inputWebSite.parentElement.style.display = "none";
                inputCompanyProfile.parentElement.style.display = "none";
                extraInfo.style.display = "block";
                minExtraInfo.style.display = "none";
            }
            extraInfo.addEventListener('click', extraExhibFields);
            minExtraInfo.addEventListener('click', minExtraExhibFields);
			inputName.addEventListener( "input", checkComplete);
			inputId.addEventListener( "input", checkComplete);
        }
        else if( commandNumber === sales.CMD_DIVIDE) {
            if( divide === null) {
                divide = new DivideTool();
                elemById( "divideContainer").appendChild( divide.tool);
                doc.addEventListener( "Divide_Booth_Numbers", checkComplete);
                if(window.innerHeight < 601){
                    elemById('divideContainer').style.margin = "-30px 10% -160px";
                }
            }
            elemById( "divideContainer").style.display = "block";
            divide.enableEvents();
        }
		else if( commandNumber === sales.CMD_CHANGE_NUMBER) {
			inputId.parentElement.style.display = "block";
			elemById( "sLblCompanyId").textContent = txt.NEW_NUMBER;
			inputId.removeAttribute( "readonly");
			inputId.value = "";
			inputId.addEventListener( "input", checkComplete);
		}
        checkComplete();
    }
    
    function newCompanyHandler() {
        inputName.removeAttribute( "readonly");
        inputName.value = "";
        checkComplete();
        inputId.parentElement.style.display = "none";
        inputName.addEventListener( "input", checkComplete);
        divCompanies.style.display = "none";
        doc.getElementById('sTable').style.display = "block";
        if( commandNumber === sales.CMD_HOLD){
            inputId.value = "";
        }
    }
    
    function closeWindow() {
        data.salesWindowOpen = false;
        data.salesWindow.window.style.display = 'none'; 
        if( /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
                divCompanies.style.margin = "50px 24px 10px 20px";
        }
        elemById('divideContainer').style.margin = "";
        doc.getElementById('sTable').style.display = "block";
        elemById('addBoothBtnA').style.display = "block";
        elemById( "sLblBthNum").classList.remove("salesComplete");
        elemById( "sLblCompanyName").classList.remove("salesComplete");
        elemById( "sLblCompanyId").classList.remove("salesComplete");
        elemById( "sLblRate").classList.remove("salesComplete");
        elemById( "sLblComment").classList.remove("salesComplete");
        elemById( "sCancel").classList.remove("salesComplete");
        elemById( "sNewComp").classList.remove("salesComplete");

        if(elemById( "info-rent") !== null){
            elemById('info-rent').style.visibility = "hidden";
        }
        if(salesPrompt.classList.contains('wrongLoginTwo')){
            salesPrompt.classList.remove('wrongLoginTwo');
        }
		if( commandNumber === sales.CMD_EVENT_STATISTICS) {
			winSales.removeChild( stats);
			stats = null;
			winSales.removeChild( statsHeader);
        }
        if(window.innerHeight < 601){
            document.querySelectorAll('.dialog__content')[1].scrollTop = 0;
            document.querySelectorAll('.dialog__content')[1].style.overflow = 'hidden';
        }
        
        boothObj = null;
        elemById( "sLblCompanyId").textContent = txt.COMPANY_ID;
		inputBthNum.value = "";
		inputName.value = "";
		inputId.value = "";
		inputId.setAttribute( "readonly", true);
        inputComment.value = "";
        inputAddrOne.value = "";
        inputAddrTwo.value = "";
        inputCity.value = "";
        inputCountry.value = "";
        inputState.value = "";
        inputPostalCode.value = "";
        inputContact.value = "";
        inputPhone.value = "";
        inputFax.value = "";
        inputEmail.value = "";
        inputWebSite.value = "";
        inputCompanyProfile.value = "";
        salesPrompt.textContent = "";
		inputRate.options.length = 0;
		inputRate.removeEventListener( "change", checkComplete);
		btnOps.textContent = txt.arSalesCommands[ commandNumber];  //?????
        btnOps.disabled = true;

        inputName.setAttribute( "readonly", true);
        salesPrompt.style.display = "block";
        extraInfo.style.display = "none";
        minExtraInfo.style.display = "none";
		inputName.parentElement.style.display = "none";
		inputId.parentElement.style.display = "none";
		inputRate.parentElement.style.display = "none";
		inputComment.parentElement.style.display = "none";
		inputBthNum.parentElement.style.display = "none";
        elemById( "sNewComp").style.display = "none";
        inputAddrOne.parentElement.style.display = "none";
        inputAddrTwo.parentElement.style.display = "none";
        inputCity.parentElement.style.display = "none";
        inputCountry.parentElement.style.display = "none";
        inputState.parentElement.style.display = "none";  
        inputPostalCode.parentElement.style.display = "none";
        inputContact.parentElement.style.display = "none";
        inputPhone.parentElement.style.display = "none";
        inputFax.parentElement.style.display = "none";
        inputEmail.parentElement.style.display = "none";
        inputWebSite.parentElement.style.display = "none";
        inputCompanyProfile.parentElement.style.display = "none";
        
        if(elemById("hatchRadioDiv") !== null){
            elemById("hatchRadioDiv").style.display = "none";
            elemById("sizeHatchDiv").style.display = "none";
            elemById("colorHatchDiv").style.display = "none";
            elemById("hatchGreyDiv").style.display = "none";
            elemById("greyHatch").style.display = "none";
            if(elemById("removeHatch") !== null){
            // elemById('removeHatch').removeEventListener('click', removeHatchBoothsHandler);
                elemById("removeHatch").style.display = "none";
            }  
        }
        if( listCompanies !== null) {
            doc.removeEventListener( "Company_Grid_Click", companyClickHandler);
            divCompanies.removeChild( divCompanyGrid);
            listCompanies = null;
            divCompanyGrid = null;
        }
        if( listDeletedBoohts !== null) {
            doc.removeEventListener( "Deleted_Booth_Click", deletedBoothClickHandler);
            divCompanies.removeChild( divCompanyGrid);
            listDeletedBoohts = null;
            divCompanyGrid = null;
        }
        if( commandNumber === sales.CMD_DIVIDE) {
            divide.close();
            elemById( "divideContainer").style.display = "none";
        }
        var el = document.getElementsByTagName('input');
        var elMsg = document.querySelector('.validate-error-msg');
        if(elMsg !== null){
            elMsg.remove();
        }
        for (var i = 0; i < el.length; i++) {
            el[i].classList.remove('validate-error');
         }
        elemById( "cSrch").value = "";
        divCompanies.style.display = "none";
        
        winSales.style.display = "none";
        doc.dispatchEvent( new FxEvent( "Sales_Window_Closed", null));
    }
    function setBoothNumber( bthObj) {
        boothObj = bthObj;
        var exhObj = null;
        var exhIndexArray;
        var i;
        var found = false;
        var add = "";
        var remove = "";
        var index = 0;
        var ar = [];
        
        if( salesMode === "Exhibitor") {
            if( boothObj.status === "0") {
//                remove = inputBthNum.value
                inputBthNum.value = boothObj.number;
                btnOps.textContent = txt.arSalesCommands[ commandNumber];  //  why here ????
                btnOps.disabled = false;
                salesPrompt.textContent = "";
            }
            else if( boothObj.status === "2") {     
                exhIndexArray = boothObj.exhibitorIndex.split( ",");
                for( i = 0; i < exhIndexArray.length; i++) {

                    if( data.exhibitors[ exhIndexArray[i]].exhId === inputId.value) {
                        btnOps.textContent = txt.arSalesCommands[ commandNumber];   
                        btnOps.disabled = false;
                        inputBthNum.value = boothObj.number;
                        salesPrompt.textContent = "";
                        found = true;
                        break;
                    }
                }
                if( !found) {
                    btnOps.disabled = true;
                    inputBthNum.value = "";
                    salesPrompt.textContent = txt.NOT_AVAILABLE;
                }
            }
            else {
                btnOps.disabled = true;
                inputBthNum.value = "";
                salesPrompt.textContent = txt.NOT_AVAILABLE;
            }
        }
        else if( salesMode === "sales") {
            if( commandNumber === sales.CMD_RENT) {
                if( boothObj.status === "0") {
                    remove = inputBthNum.value;
                    inputBthNum.value = boothObj.number;
                    add = boothObj.number;
                    salesPrompt.textContent = txt.SELECT_BOOTH;
                }
                else if( boothObj.status === "1") {         //  EDGE won't rent it !!
                    exhObj = data.exhibitors[ boothObj.exhibitorIndex];
                    if( exhObj !== null && exhObj.name === inputName.value) {
                        remove = inputBthNum.value;
                        inputBthNum.value = boothObj.number;
                        add = boothObj.number;
                    }
                    else {
                        salesPrompt.textContent = txt.NOT_AVAILABLE;
                    }
                }
                else {
                    salesPrompt.textContent = txt.NOT_AVAILABLE;
                }
            }
            else if( commandNumber === sales.CMD_UNRENT) {
                if( boothObj.status === "2") {
                    remove = inputBthNum.value;
                    inputBthNum.value = boothObj.number;
                    add = boothObj.number;
                    salesPrompt.textContent = txt.SELECT_BOOTH;
                    if(inputBthNum.value !== ""){
                        returnSalesWindow()
                    }
                }
                else {
                    remove = inputBthNum.value;
                    inputBthNum.value = "";
                    salesPrompt.textContent = txt.NOT_RENTED;
                }
            }
            else if ( commandNumber === sales.CMD_UNHOLD) {
                remove = inputBthNum.value;
                if(  boothObj.status === "1") {
                    inputBthNum.value = boothObj.number;
                    add = boothObj.number;
                    salesPrompt.textContent = txt.SELECT_BOOTH;
                }
                else {
                    inputBthNum.value = "";
                    salesPrompt.textContent = txt.NOT_ON_HOLD;
                }
            }
            else if( commandNumber === sales.CMD_DIVIDE) {
                if( boothObj.status === "0") {
                    if( boothObj.dimF !== "") {         //  Filter OUT non-rectangular booths
                        remove = inputBthNum.value;
                        inputBthNum.value = boothObj.number;
                        add = boothObj.number;
                        salesPrompt.textContent = txt.ENTER_BOOTH_NUMBERS;

                        divide.drawBooth( boothObj);
                    }
                }
                else {
                    salesPrompt.textContent = txt.NOT_AVAILABLE;
                }
            }
            else if( boothObj.status === "0") {
                if( inputBthNum.value && ( commandNumber === sales.CMD_COMBINE || commandNumber === sales.CMD_DELETE) ) {
                    //  CHECK IF NUMBER IS ALREADY IN STRING
                    ar = inputBthNum.value.split( ", ");
                    index = ar.indexOf( boothObj.number);
                    if( index !== -1) {
                        ar.splice( index, 1);
                        inputBthNum.value = ar.join( ", ");
                        remove = boothObj.number;
                    } 
                    else {
                        inputBthNum.value += ", " + boothObj.number;
                        add = boothObj.number;
                        elemById('sLblBthNum').classList.add('salesComplete');
                        returnSalesWindow();
                    }

                }
                else {
                    remove = inputBthNum.value;
                    inputBthNum.value = boothObj.number;
                    add = boothObj.number;
                    salesPrompt.textContent = txt.SELECT_BOOTH;
                    returnSalesWindow();
                }
            }
            else {
                remove = inputBthNum.value;
                inputBthNum.value = "";
                salesPrompt.textContent = txt.NOT_AVAILABLE;
            }
            checkComplete();
        }
        return { "select": add, "unselect": remove};		// controls highlighting booths on floor plan
    }
    
    function deletedBoothListHandler( evt) {
        doc.removeEventListener( "Result_Deleted_Booths", deletedBoothListHandler);
        if( !evt.data || evt.data.length === 0) {
            salesPrompt.textContent = txt.NO_DELETED_BOOTHS;
        }
        else {
            if( listDeletedBoohts === null) {
                divCompanyGrid = doc.createElement( "div");
                divCompanyGrid.setAttribute( "id", "companies");
                divCompanies.appendChild( divCompanyGrid);
                divCompanyGrid.style.height = "360px";
                
                listDeletedBoohts = new DeletedBoothList( divCompanyGrid);
            }
//            elemById( "companyHeader").style.display = "none";
            divCompanies.style.display = "block";
            
            listDeletedBoohts.setBooths( evt.data);
            doc.addEventListener( "Deleted_Booth_Click", deletedBoothClickHandler);
        }
    }
	
	function eventStatisticsHandler( evt) {
		doc.removeEventListener( "Result_Event_Statistics", eventStatisticsHandler);
		
		if( statsHeader === null) {
			statsHeader = doc.createElement( "div");
			statsHeader.className = "statsHeader";
			salesPrompt.textContent = btnOps.textContent;
		}
		winSales.insertBefore(statsHeader, salesAction);
			
		stats = new StatsList( evt.data);
		
		winSales.insertBefore( stats, salesAction);
	}
    
    function deletedBoothClickHandler( evt) {
		doc.removeEventListener( "Deleted_Booth_Click", deletedBoothClickHandler);
        inputBthNum.value = evt.data.boothNumber;
        checkComplete();
    }
    
    function companyClickHandler( evt) {        // for sales mode
        if( inputId.parentElement.style.display === "none") {
            inputId.parentElement.style.display = "block";
            inputName.setAttribute( "readonly", true);
        }
        inputName.value = evt.data.companyName;
        console.log(data.exhibitors)
        data.exhibitors.map(item => {
            if(item.exhId === evt.data.companyId){
                console.log(item)
                tooltipObj = item
            }
        }) 

        inputId.value = evt.data.companyId;
        checkComplete();
    }
    
    function setCompany( name, id, rate) {      //  for exhibitor mode
        inputName.value = name;
        inputId.value = id;
        if( rate !== null && rate !== "") {
            //  find rate in options and set to selected
           // alert( "Not Updated to Select Element");
            swal("", "Not Updated to Select Element", "error");
            inputRate.value = rate;
        }
        checkComplete();
    }
    
    function companyListHandler( evt) {
        if( evt.data) {
            if( listCompanies === null) {
                
                divCompanyGrid = doc.createElement( "div");
                divCompanyGrid.setAttribute( "id", "companies");
                divCompanies.appendChild( divCompanyGrid);
                divCompanyGrid.style.height = "350px";
                divCompanyGrid.style.width = "353px";
                
                listCompanies = new CompanyList( divCompanyGrid, txt.EXHIBITORS);
            }
            
            divCompanies.style.display = "none";
//            elemById( "companyHeader").style.display = "block";
            
            if( commandNumber === sales.CMD_RENT) {
                sales.getRatePlans();
                doc.addEventListener( "Result_Rate_Plans", rateListHandler);
                //divCompanies.style.display = "none";
            }
            if( commandNumber === sales.CMD_HOLD) {
                divCompanies.style.display = "none"; 
            }
            listCompanies.setCompanies( evt.data);
            doc.addEventListener( "Company_Grid_Click", companyClickHandler);
            
            doc.removeEventListener( "Companies_Result", companyListHandler);
        }
    }
    
    function rateListHandler( evt) {
        var numPlans = evt.data.length;
        var ratePlans = [];
        var i = 0;
        
        for( i = 0; i < numPlans; i++) {
            ratePlans.push( evt.data[i].Name);
        }
        
        if( config.sortRatePlans === "asc") {
            ratePlans.sort();
        }
        else if( config.sortRatePlans === "desc") {
            ratePlans.sort( descend);
        }
        
        inputRate.options.length = 0;
        inputRate.appendChild( elem.filterItem( txt.SELECT_RATE,
                                               txt.SELECT_RATE, false));
        
        for( i = 0; i < numPlans; i++) {
            inputRate.appendChild( elem.filterItem( ratePlans[i], ratePlans[i], false));
        }
        inputRate.addEventListener( "change", checkComplete);
    }
    
    function descend( a, b) {
        if ( b < a) {
            return -1;
        }
        if ( b > a) {
            return 1;
        }
        return 0;
    }
    
    function sendCommand() {
        var params = null;
		
		switch( commandNumber) {
			case sales.CMD_RENT:
                sales.rentBoothRequest( inputBthNum.value, inputId.value, inputRate.value);
				break;
			case sales.CMD_UNRENT:
				sales.unrentBoothRequest( inputBthNum.value);
				break;
			case sales.CMD_HOLD:
				sales.holdBoothRequest( inputBthNum.value, inputId.value,
                                  inputName.value, inputComment.value);
				break;
			case sales.CMD_UNHOLD:
				sales.unholdBoothRequest( inputBthNum.value);
				break;
			case sales.CMD_COMBINE:
				sales.combineBoothRequest( inputBthNum.value);
				break;
			case sales.CMD_UNCOMBINE:
				sales.uncombineBoothRequest( inputBthNum.value);
				break;
			case sales.CMD_DELETE:
				sales.deleteBoothRequest( inputBthNum.value);
				break;
			case sales.CMD_UNDELETE:
				sales.undeleteBoothRequest( inputBthNum.value);
				break;
			case sales.CMD_NEW_EXHIBITOR:
                sales.createNewExhibitor( inputName.value, inputId.value, inputAddrOne.value, 
                                        inputAddrTwo.value, inputCity.value, inputCountry.value, 
                                        inputState.value, inputPostalCode.value, inputContact.value, 
                                        inputPhone.value, inputFax.value, inputEmail.value, 
                                        inputWebSite.value, inputCompanyProfile.value);
				break;
			case sales.CMD_DIVIDE:
				params = divide.getParameters();
				sales.divideBoothRequest( inputBthNum.value, params);
				break;
			case sales.CMD_CHANGE_NUMBER:
				sales.changeBoothNumber( inputBthNum.value, inputId.value);
                break;
            case sales.CMD_HATCH_BOOTHS:
               // var color = "";
               // var availability = 3;
               // var size = "400 SqFt"; //400 SqFt //10' x 20'
                var specified = "10,43,65,24,79";
               // var grey = true;

                mapHatchObj()

                sales.hatchBooths(hatchObj.color, hatchObj.radio, hatchObj.size, hatchObj.grey, specified);
                
                //Hack? Should only close if hatchBooths has items based on criteria
                closeWindow();
                break;
                    
			gkidefault:
				console.log( "command number  " + commandNumber + "  is not defined");
		}
        doc.addEventListener( "Sales_Result", commandResult);
    }
    
    function commandResult( evt) {
        doc.removeEventListener( "Sales_Result", commandResult);
        if( commandNumber === sales.CMD_NEW_EXHIBITOR) {
            if( evt.data === null) {
                closeWindow();
            }
            else {
                salesPrompt.textContent = evt.data.Message;
                salesPrompt.classList.add('wrongLoginTwo');
            }
        }
        else if( evt.data) {
            if( evt.data.hasOwnProperty( "Code") && evt.data.Code < 0) {
               salesPrompt.textContent = evt.data.Code + "   " + evt.data.Message;
            } 
            else {
				if( commandNumber === sales.CMD_UNDELETE) {
						// save booth number to allow zoom to booth when booth info available
					data.pendingZoomBoothNumber = inputBthNum.value;
				}
				
                inputBthNum.value = "";
                btnOps.disabled = true;
                sales.syncNow(); 
                
                closeWindow();
            }
        }
        else {
            console.log( "Command Failed  " + evt.Message);
        }
    }

    //Form Max length Detect
    var arr = [inputBthNum,
                inputName,
                inputId,
                inputComment,
                inputAddrOne,
                inputAddrTwo,
                inputCity,
                inputCountry,
                inputState,
                inputPostalCode,
                inputContact,
                inputPhone,
                inputFax,
                inputEmail,
                inputWebSite,
                inputCompanyProfile];

    arr.forEach(function (item) {
        item.onkeydown = function() {
            if (this.value.length === parseInt(this.attributes["maxlength"].value)) {
                    item.classList.add('validate-error')
                if(!document.body.contains(document.querySelector('.validate-error-msg'))){
                    item.insertAdjacentHTML('afterend', '<small class="validate-error-msg">'+ characterLimit +'</small>');
                }
            } else{
                if(document.body.contains(document.querySelector('.validate-error-msg'))){
                    document.querySelector('.validate-error-msg').remove();
                }
                item.classList.remove('validate-error');
            }
        } 
    });
   
    return {
        closeWindow: closeWindow,
        openWindow: openWindow,
        setBoothNumber: setBoothNumber,
        setCompany: setCompany,
    };
};